module.exports = __webpack_public_path__ + "static/media/shovel-snow.9986b932.svg";